module.exports = __webpack_public_path__ + "static/media/skip.922d7064.svg";